// extracted by mini-css-extract-plugin
export default {"container":"topArea_container__WSwcG"};